import { getData, postData } from '@/views/mped/services/mped-service';

export const getUploadedHistorySapData = async (args) => {
  return getData({
    url: '/amortization/upload/history',
    uuid: 'eda0444d-8c9e-4065-b742-f444b382ade9',
    args,
    fullResponse: true
  });
};

export const getMainAsset = async (args) => {
  return getData({
    url: '/amortization/main-asset',
    uuid: '112a303b-95fd-498c-88d4-3ed7a0c348df',
    args,
    fullResponse: true
  });
};

export const getUploadedViewData = async (args) => {
  return getData({
    url: '/amortization/upload/view',
    uuid: '14849f2a-5b19-4af3-a371-9252537a9828',
    args,
    fullResponse: true
  });
};

export const getMoveMainAsset = async (args) => {
  return getData({
    url: '/amortization/move-main-asset',
    uuid: 'f91e483e-90de-499a-870b-5615adf7bbb2',
    args,
    fullResponse: true
  });
};

export const setMoveMainAsset = async (args) => {
  return postData({
    url: '/amortization/move-main-asset',
    uuid: '1a01fa2e-06af-4020-818c-6ebed12e282d',
    args,
    throwError: true
  });
}

export const getCalculation = async (args) => {
  return getData({
    url: '/amortization/calculation',
    uuid: '31c8377e-bd84-405d-a50d-3bec171d9d60',
    args,
    fullResponse: true
  });
};

export const getUploadPeriods = async (args) => {
  return getData({
    url: '/amortization/upload/period',
    uuid: '3eeaf38d-b70e-4150-81f1-d7678d235546',
    args,
    fullResponse: true
  });
};

export const setCalculation = async (args) => {
  return postData({
    url: '/amortization/calculation',
    uuid: '2fda4acc-5738-4ade-9438-00a786b0a6de',
    args
  });
};

export const setCalculationValidate = async (args) => {
  return postData({
    url: '/amortization/calculation/validation',
    uuid: 'f2dc8c3c-8f21-43fe-9fc7-6b2a6db8ef56',
    args
  });
};

export const getCalculationHistory = async (args) => {
  return getData({
    url: '/amortization/calculation/history',
    uuid: 'f2dc8c3c-8f21-43fe-9fc7-6b2a6db8ef56',
    args
  });
};

export const getDistribution = async (args) => {
    return getData({
        url: '/mped/mped-amortization-distribution-view-select',
        uuid: '4fffde4a-404a-4bd8-adf3-f344b88f5955',
        args,
        fullResponse: true
    });
};

export const setDistribution = async (args) => {
    return postData({
        url: '/mped/mped-amortization-distribution-view-save',
        uuid: '81763011-b862-43e4-97bc-0ea636d8281f',
        args,
        throwError: true
    });
}

export const getDistributionLookup = async () => {
    return getData({
        url: '/mped/as-amortization-main-asset-lookup-select',
        uuid: '696712ba-d65a-4b6e-88fd-c1fc39a3b7ee',
        fullResponse: true
    });
};

export const getExcluding = async (args) => {
    return getData({
        url: '/mped/mped-amortization-excluding-asset-view-select',
        uuid: 'cfbe784f-d8e5-429b-ae5c-f832d725e08c',
        args,
        fullResponse: true
    });
};

export const setExcluding = async (args) => {
    return postData({
        url: '/mped/mped-amortization-excluding-asset-view-save',
        uuid: 'd706586b-5472-4fb2-af6e-b3fa7d000488',
        args,
        throwError: true
    });
}

export const getAmortizationGroups = async () => {
    return getData({
        url: '/mped/mped-amortization-group-view-select',
        uuid: '4fffde4a-404a-4bd8-adf3-f344b88f5955',
        fullResponse: true
    });
};

export const setAmortizationGroups = async (args) => {
    return postData({
        url: '/mped/mped-amortization-group-view-save',
        uuid: 'b10bb6ee-5e0b-4569-9d7a-cf9a53e46ce0',
        args,
        throwError: true
    });
}

export const setPlanWorkGroup = async (args) => {
    return postData({
        url: '/amortization/plan-work-group',
        uuid: 'd0e4b95e-f6da-41f6-8f31-2583a8ef2ba0',
        args,
        throwError: true,
    });
};

export const getPlanWorkGroup = async (args) => {
    return getData({
        url: '/amortization/plan-work-group',
        uuid: '422237c2-d29b-4d6f-8627-0412452d8db0',
        args
    });
};

export const getCalculationDetail = async (args) => {
  return getData({
    url: '/amortization/calculation/distribution',
    uuid: 'f46253d0-ea67-4c1c-b127-6dc146123684',
    args
  });
};
